import MonitoringSetting from "./monitoring-setting";

class AscmuMonitoringEventStatus {
  constructor() {
    this._monitoringEventId;
    this._timestampMsec;
    this._beaconType;
    this._contactStatus;
    this._contactTypeCd;
    this._contactEvent;
    this._notificationTitle;
  }

  get monitoringEventId() {
    return this._monitoringEventId;
  }

  set monitoringEventId(value) {
    this._monitoringEventId = value;
  }

  get timestampMsec() {
    return this._timestampMsec;
  }

  set timestampMsec(value) {
    this._timestampMsec = value;
  }

  get beaconType() {
    return this._beaconType;
  }

  set beaconType(value) {
    this._beaconType = value;
  }

  get contactStatus() {
    return this._contactStatus;
  }

  set contactStatus(value) {
    this._contactStatus = value;
  }

  get contactTypeCd() {
    return this._contactTypeCd;
  }

  set contactTypeCd(value) {
    this._contactTypeCd = value;
  }

  get contactEvent() {
    return this._contactEvent;
  }

  set contactEvent(value) {
    this._contactEvent = value;
  }

  get notificationTitle() {
    return this._notificationTitle;
  }

  set notificationTitle(value) {
    this._notificationTitle = value;
  }
}

/* eslint-disable no-unused-expressions */
class AscmuMonitoringSetting extends MonitoringSetting {
  constructor(monitoringTargetId, monitoringSettingId = null) {
    super(monitoringTargetId, monitoringSettingId);
    this.monitoringSettingType = "ascmu";
  }

  copy() {
    const monitoringSetting
      = new AscmuMonitoringSetting(this.monitoringTargetId, this.monitoringSettingId);
    monitoringSetting.copyProperties(this);
    return monitoringSetting;
  }

  setApiResponseJosn(item) {
    super.setApiResponseJosn(item);
    this.monitoringTargetId = item.monitoring_target_id;
    this.monitoringSettingId = item.monitoring_setting_id;
    this.monitoringSettingType = item.monitoring_setting_type;
    this.monitoringDeviceId = item.monitoring_device_id;
    this.monitoringEventStatus = new AscmuMonitoringEventStatus();

    console.log(item);
    if (item.monitoring_event_status) {
      this.monitoringEventStatus.monitoringEventId
        = item.monitoring_event_status.monitoring_event_id;
      this.monitoringEventStatus.timestampMsec = item.monitoring_event_status.timestamp_msec;
      this.monitoringEventStatus.beaconType = item.monitoring_event_status.beacon_type;
      this.monitoringEventStatus.contactStatus = item.monitoring_event_status.contact_status;
      this.monitoringEventStatus.contactTypeCd = item.monitoring_event_status.contact_type_cd;
      this.monitoringEventStatus.contactEvent = item.monitoring_event_status.contact_event;
      this.monitoringEventStatus.notificationTitle
        = item.monitoring_event_status.notification_title;
    }
    this.organizationId = item.organization_id;
    this.projectId = item.project_id;
  }
}
/* eslint-enable */

export {
  AscmuMonitoringSetting,
  AscmuMonitoringEventStatus,
};
